let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4xN4A")).then(() => parcelRequire('98VOu'));